import React from 'react';
import { TextInput, StyleSheet, TextInputProps, View, Text } from 'react-native';
import { Brand, Neutrals } from '@/constants/theme';

interface InputProps extends TextInputProps {
  label?: string;
  error?: string;
  containerStyle?: object;
}

export function Input({ label, error, style, containerStyle, ...props }: InputProps) {
  return (
    <View style={[styles.container, containerStyle]}>
      {label && <Text style={styles.label}>{label}</Text>}
      <TextInput
        style={[
          styles.input,
          error && styles.inputError,
          props.multiline && styles.inputMultiline,
          style,
        ]}
        placeholderTextColor={Neutrals.textMuted}
        {...props}
      />
      {error && <Text style={styles.errorText}>{error}</Text>}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    color: Neutrals.textPrimary,
    marginBottom: 8,
  },
  input: {
    minHeight: 48,
    borderWidth: 2,
    borderColor: Neutrals.border,
    borderRadius: 16,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 16,
    backgroundColor: Neutrals.whiteFaded70,
    color: Neutrals.textPrimary,
  },
  inputMultiline: {
    paddingTop: 12,
    textAlignVertical: 'top',
  },
  inputError: {
    borderColor: Brand.destructive,
  },
  errorText: {
    fontSize: 12,
    color: Brand.destructive,
    marginTop: 4,
  },
});
